import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown-content',
  templateUrl: './dropdown-content.component.html',
  styleUrls: ['./dropdown-content.component.scss'],
})
export class DropdownContentComponent  implements OnInit {
  @Input() addCustomClass: string;
  @Input() addHeaderCustomClass: string;
  @Input() isOpen: boolean = false;
  @Output() itemClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  toggleContent() {
    this.itemClicked.emit();
  }

}
